import { render, staticRenderFns } from "./ResetAdminPassDialog.vue?vue&type=template&id=b601191a&"
import script from "./ResetAdminPassDialog.vue?vue&type=script&lang=js&"
export * from "./ResetAdminPassDialog.vue?vue&type=script&lang=js&"
import style0 from "./ResetAdminPassDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports